
/*
 * Date: 2025
 * Description: Escape button for modal dialogs
 * Author: Philippe Leroux @ Skitsc
 */

//Modules
import { IconButton  } from "@mui/material"
import CloseSharpIcon from '@mui/icons-material/CloseSharp';

interface i_close_modal {
    handleClose : ( bool : boolean ) => void;
}
const CloseModal = ({ handleClose } : i_close_modal ) => {
    return (
        <IconButton onClick={() => handleClose(false)} style={{float : "right"}}>
            <CloseSharpIcon/>
        </IconButton>
    )
}

export default CloseModal